import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_EMAIL').plugin(axiosPlugin);

let updateUserEmailAction = redux.fetchActionUpdate();

export const updateUserEmail = (userId, data = {}) => updateUserEmailAction(`/users/${userId}/update-email`, data);

export const userEmail = redux.reducer();